const LOG_PREFIX = "[PlanWorkflows]";

/** Activo en development o con localStorage DEBUG_PLAN_WORKFLOWS=1 */
export const isPlanWorkflowDebugEnabled = () => {
	if (typeof window === "undefined") return false;
	if (process.env.NODE_ENV === "development") return true;
	try {
		return window.localStorage?.getItem("DEBUG_PLAN_WORKFLOWS") === "1";
	} catch (_) {
		return false;
	}
};

export const planWorkflowDebug = (...args) => {
	if (!isPlanWorkflowDebugEnabled()) return;
	console.log(LOG_PREFIX, ...args);
};

export const planWorkflowDebugWarn = (...args) => {
	if (!isPlanWorkflowDebugEnabled()) return;
	console.warn(LOG_PREFIX, ...args);
};
